import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiBaseResponseDto, ApiPaginatedResponseDto } from '../common-dtos';
import {
  ImGroupCreateRequestDto,
  ImGroupDto,
  ImGroupListRequestDto,
  ImGroupMemberDto,
  ImGroupMembersAddRequestDto,
  ImGroupMembersDeleteRequestDto,
  ImGroupMembersListRequestDto,
  ImGroupUpdateRequestDto,
} from './dtos';

@Injectable({ providedIn: 'root' })
export class ImGroupApiService {
  constructor(private readonly http: HttpClient) {}

  public getGroups(request: ImGroupListRequestDto): Observable<ApiPaginatedResponseDto<ImGroupDto>> {
    return this.http.post<ApiPaginatedResponseDto<ImGroupDto>>('/bvcsp/v1/imgroup/list', request);
  }

  public getGroup(groupId: string): Observable<ImGroupDto | null> {
    return this.http
      .get<ApiBaseResponseDto<ImGroupDto>>(`/bvcsp/v1/imgroup/info/${groupId}`)
      .pipe(map((response) => response.data ?? null));
  }

  public createGroup(request: ImGroupCreateRequestDto): Observable<ImGroupDto> {
    return this.http
      .post<ApiBaseResponseDto<ImGroupDto>>('/bvcsp/v1/imgroup/create', request)
      .pipe(map((response) => response.data!));
  }

  public updateGroup(groupId: string, request: ImGroupUpdateRequestDto): Observable<ImGroupDto> {
    return this.http
      .put<ApiBaseResponseDto<ImGroupDto>>(`/bvcsp/v1/imgroup/${groupId}`, request)
      .pipe(map((response) => response.data!));
  }

  public deleteGroup(groupId: string): Observable<unknown> {
    return this.http.delete<unknown>(`/bvcsp/v1/imgroup/${groupId}`);
  }

  public getGroupMembers(
    groupId: string,
    request: ImGroupMembersListRequestDto,
  ): Observable<ApiPaginatedResponseDto<ImGroupMemberDto>> {
    return this.http.post<ApiPaginatedResponseDto<ImGroupMemberDto>>(
      `/bvcsp/v1/imgroup/members/list/${groupId}`,
      request,
    );
  }

  public getGroupMember(groupId: string, memberId: string): Observable<ImGroupMemberDto | null> {
    return this.http
      .get<ApiBaseResponseDto<ImGroupMemberDto>>(`/bvcsp/v1/imgroup/member/info/${groupId}/${memberId}`)
      .pipe(map((response) => response.data ?? null));
  }

  public addGroupMember(groupId: string, request: ImGroupMembersAddRequestDto): Observable<ImGroupMemberDto[]> {
    return this.http
      .post<ApiBaseResponseDto<ImGroupMemberDto[]>>(`/bvcsp/v1/imgroup/members/add/${groupId}`, request)
      .pipe(map((response) => response.data ?? []));
  }

  public deleteGroupMember(groupId: string, request: ImGroupMembersDeleteRequestDto): Observable<ImGroupMemberDto[]> {
    return this.http
      .post<ApiBaseResponseDto<ImGroupMemberDto[]>>(`/bvcsp/v1/imgroup/members/del/${groupId}`, request)
      .pipe(map((response) => response.data ?? []));
  }
}
